/*jshint esversion: 6 */
// import Vue from 'vue';
// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  example: 'example',
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getExample: ( state ) => (id) => {
    return state.example[id];
  },
};
// Actions
const actions = {
  setExample({commit, payload}){
    commit('set_example', payload);
  },
};
// Mutations
const mutations = {
  set_example(state, payload) {
    state.example = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
